import { useMutation } from "@apollo/client";

import { SettingsFunctionTypeEditRoute_DeleteDocument } from "../mutations.generated";

export default function useSettingsFunctionTypeEditRoute_Delete() {
    const [mutate, { loading, error }] = useMutation(SettingsFunctionTypeEditRoute_DeleteDocument, {});

    const deleteFunctionType = async (ecologicalFunctionTypeId: string) => {
        mutate({ variables: { input: { ecologicalFunctionTypeId } } });
    };

    return {
        deleteFunctionType,
        loading,
        error,
    };
}
